import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from "../../providers/order/order";
import { PosmItemProvider } from "../../providers/posm-item/posm-item";
import { PosmItem } from "../../models/posm-item.model";

import { PosmSubitemsPage } from '../posm-subitems/posm-subitems';
import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';

import { BasketPage } from "../basket/basket";
import { OrdersListPage } from "../orders-list/orders-list";

import { Storage } from '@ionic/storage';
@IonicPage()
@Component({
  selector: 'page-posm-items',
  templateUrl: 'posm-items.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class PosmItemsPage extends BasketPage {
  public orderList: OrdersListPage;
  public loading: boolean;

  public posmCategoryName: string;
  public posmCategoryTitle: string;
  public posmCategoryContent: string;

  public posmItems: PosmItem[];
  public showPosmItems: PosmItem[];

  public products;
  public productFilterId: number = 0;

  private posmCategoryID: number;

  constructor(public storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, private posmItemProvider: PosmItemProvider, public modalCtrl: ModalController, public authProvider: AuthProvider) {
    super(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl, authProvider);
    this.orderList = new OrdersListPage(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl);

    this.posmCategoryID = navParams.get('posmCategoryId');
    this.posmCategoryName = navParams.get('posmCategoryName');
    this.posmCategoryTitle = navParams.get('posmCategoryTitle');
    this.posmCategoryContent = navParams.get('posmCategoryContent');
  }

  getPosmItems() {
    this.loading = true;
    this.posmItemProvider.getByPosmCategoryID(this.posmCategoryID)
      .subscribe(
        posmItems =>{
          this.posmItems = posmItems
          this.reloadBasketContent();
          this.getPosmItemsValues();
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.events.publish('orderList:get_data');
          this.loading = false;
        }
      );
  }

  filterByProduct(product_id: number) {
    if (product_id == -1) {
      this.productFilterId = 0;
    } else {
      this.productFilterId = product_id;
    }
    this.getPosmItemsValues();
  }

  getPosmItemsValues () {
    this.showPosmItems = new Array();
    this.products = new Array();
    for (const key of Object.keys(this.posmItems)) {
      for (const product_key of Object.keys(this.posmItems[key].products)) {
        if (this.products.map((product) => product.id).indexOf(parseInt(this.posmItems[key].products[product_key].product_id)) === -1) {
          this.products.push({
            id: parseInt(this.posmItems[key].products[product_key].product_id),
            name: this.posmItems[key].products[product_key].product_name,
          });
        }

        if ((this.productFilterId !== 0 && parseInt(this.posmItems[key].products[product_key].product_id) === this.productFilterId)
          || this.productFilterId === 0) {
          this.showPosmItems[key] = this.posmItems[key];
        }
      }
    }
  }

  reloadPosmItems(refresher) {
    this.getPosmItems();
    refresher.complete();
  }

  selectPosmSubitemsByItem(item: PosmItem) {
    this.navCtrl.push(PosmSubitemsPage, {
      parentID: item.id,
      parentName: item.translation || item.name,
      parentTitle: item.title || item.translation || item.name,
      parentContent: item.content || "",
      parentImage: item.image_url || "",
      parentType: "POSM_ITEM"
    });
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getPosmItems();
  }

}



// WEBPACK FOOTER //
// ./src/pages/posm-items/posm-items.ts